import React from "react";
import { FocusCards } from "./focus-cards";

const Screenshots = () => {
    const cards = [
        {
          title: "15 Mins Book Summaries",
          src: "/Images/SS_1.png",
        },
        {
          title: "Words That Inspire",
          src: "/Images/SS_2.png",
        },
        {
          title: "Quick Book Insights",
          src: "/Images/SS_3.png",
        },
        {
          title: "Audio On-The-Go",
          src: "/Images/SS_4.png",
        },
        {
          title: "Choose Your Interest",
          src: "/Images/SS_5.png",
        },
        {
          title: "Listen Again Anytime",
          src: "/Images/SS_6.png",
        },
      ];
     
      return (
      <div className="h-full w-full flex md:items-center md:justify-center bg-zinc-50 dark:bg-zinc-900  text-slate-950 transition-bg relative overflow-visible">
        <FocusCards cards={cards} />;
      </div>
      );
    
  };

export default Screenshots;
